var murmur3 = require("./murmurhash3_gc.js");
var murmur2 = require("./murmurhash2_gc.js");
module.exports = murmur3;
module.exports.murmur3 = murmur3;
module.exports.murmur2 = murmur2;